import { produce } from 'immer';
import { combine } from 'zustand/middleware';

const serviceParams = combine({ serviceParams: {} }, (set) => ({
  addServiceParams: (newState) =>
    set(({ hsptlzForm }) => {
      hsptlzForm.serviceParams = newState;
    }),
}));

const patientInfoData = combine({ patientInfoData: {} }, (set) => ({
  setPatientInfoData: (newState) =>
    set(({ hsptlzForm }) => {
      hsptlzForm.patientInfoData = newState;
    }),
}));

const userHsptlzFormData = combine({ processFormData: [], submittedFormData: [] }, (set) => ({
  setProcessFormData: (newState) =>
    set(({ hsptlzForm }) => {
      hsptlzForm.processFormData = newState;
    }),
  setSubmittedFormData: (newState) =>
    set(({ hsptlzForm }) => {
      hsptlzForm.submittedFormData = newState;
    }),
}));

const caregiverData = combine({ caregiverData: {} }, (set) => ({
  setCaregiverData: (newState) =>
    set(({ hsptlzForm }) => {
      hsptlzForm.caregiverData = newState;
    }),
}));

const redirectData = combine({ redirectData: {} }, (set) => ({
  setRedirectData: (newState) =>
    set(({ hsptlzForm }) => {
      hsptlzForm.redirectData = newState;
    }),
}));

const sign = combine({ sign: {}, signCanvasCtx: null, signCanvasPlaceHolder: true }, (set) => ({
  setSign: (newState) =>
    set(({ hsptlzForm }) => {
      hsptlzForm.sign = newState;
    }),

  setSignCanvasCtx: (newState) =>
    set(({ hsptlzForm }) => {
      hsptlzForm.signCanvasCtx = newState;
    }),

  setSignCanvasPlaceHolder: (newState) =>
    set(({ hsptlzForm }) => {
      hsptlzForm.signCanvasPlaceHolder = newState;
    }),
}));

const contentDetailData = combine({ contentDetailData: {} }, (set) => ({
  setContentDetailData: (newState) =>
    set(({ hsptlzForm }) => {
      hsptlzForm.contentDetailData = newState;
    }),
}));

const nonBenefitList = combine({ nonBenefitList: [] }, (set) => ({
  setNonBenefitList: (newState) =>
    set(({ hsptlzForm }) => {
      hsptlzForm.nonBenefitList = newState;
    }),
}));

// 최초 1회 validation skip
const firstSubmitForm = combine({ firstSubmitForm: true }, (set) => ({
  setFirstSubmitForm: (newState) =>
    set(({ hsptlzForm }) => {
      hsptlzForm.firstSubmitForm = newState;
    }),
}));

export const createHsptlzFormSlice = (set, get) => ({
  ...serviceParams(set, get),
  ...redirectData(set, get),
  ...patientInfoData(set, get),
  ...userHsptlzFormData(set, get),
  ...caregiverData(set, get),
  ...sign(set, get),
  ...contentDetailData(set, get),
  ...nonBenefitList(set, get),
  ...firstSubmitForm(set, get),
});
